<template>
  <div>
    <v-card style="width: 320px;">
      <v-card-title class="justify-center">
        <v-img :src="$root.cdn + 'logo.png'" max-width="180" class="mx-auto mb-1" />
        Forgot Password
      </v-card-title>
      <v-card-text>
        Enter the email address associated with your account below
        <v-text-field
          v-model="email"
          label="Email"
          outlined
          hide-details
          class="mb-2"
          type="email"
          :disabled="requesting"
          @keydown="checkKeypress"
        />
        <div class="text-center mt-4">
          <v-btn color="primary" :loading="requesting" @click="requestReset" :disabled="!email">Submit</v-btn>
        </div>
        <div class="text-center mt-4">
          <router-link :to="{name: 'auth'}" style="text-decoration: none;">Back To Login</router-link>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AuthForgot',
  data: () => ({
    email: null,
    requesting: false
  }),
  methods: {
    requestReset() {
      this.requesting = true
      let params = {
        email: this.email
      }

      this.$http.post('auth/forgot-password', params)
        .then(() => {
          this.$swal.fire({
            title: 'Check Your Email',
            html: 'Reset instructions have been sent to the email submitted if an active account was found',
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: true
          })
          this.$router.push({name: 'auth'})
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error submitting your request. Please try again.', 'error')
          this.requesting = false
        })
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.requestReset()
    }
  }
}
</script>